import BaseController from './base_controller'

export default class extends BaseController {
  static values = { imo: String, system: String, type: String }

  open() {
    this.showLoading()
    $.ajax({
      type: 'POST',
      url: `/calculator/${this.systemValue}/${this.typeValue}/sensitivity-matrix?imo=${this.imoValue}`,
      data: $(this.element.closest('form')).serialize(),
      dataType: 'script',
      error: (_xhr, status, error) => console.error('Sensitivity matrix request failed:', status, error)
    })
  }
}
